import {
  FETCH_WAREHOUSE_LIST,
  RESET_WAREHOUSE_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

const warehouseListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WAREHOUSE_LIST:
      return { list: action.payload, others: action.others };
    case RESET_WAREHOUSE_LIST:
      return initialState;
    default:
      return state;
  }
};

export default warehouseListReducer;
